'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _matrixJsSdk = require('matrix-js-sdk');

var _utils = require('matrix-js-sdk/lib/utils');

var _utils2 = _interopRequireDefault(_utils);

var _eventTimeline = require('matrix-js-sdk/lib/models/event-timeline');

var _eventTimeline2 = _interopRequireDefault(_eventTimeline);

var _eventTimelineSet = require('matrix-js-sdk/lib/models/event-timeline-set');

var _eventTimelineSet2 = _interopRequireDefault(_eventTimelineSet);

var _index = require('./index');

var _index2 = _interopRequireDefault(_index);

var _createMatrixClient = require('./utils/createMatrixClient');

var _createMatrixClient2 = _interopRequireDefault(_createMatrixClient);

var _SettingsStore = require('./settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

var _MatrixActionCreators = require('./actions/MatrixActionCreators');

var _MatrixActionCreators2 = _interopRequireDefault(_MatrixActionCreators);

var _Modal = require('./Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _crypto = require('matrix-js-sdk/lib/crypto');

var _MatrixClientBackedSettingsHandler = require('./settings/handlers/MatrixClientBackedSettingsHandler');

var _MatrixClientBackedSettingsHandler2 = _interopRequireDefault(_MatrixClientBackedSettingsHandler);

var _StorageManager = require('./utils/StorageManager');

var StorageManager = _interopRequireWildcard(_StorageManager);

var _IdentityAuthClient = require('./IdentityAuthClient');

var _IdentityAuthClient2 = _interopRequireDefault(_IdentityAuthClient);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wrapper object for handling the js-sdk Matrix Client object in the react-sdk
 * Handles the creation/initialisation of client objects.
 * This module provides a singleton instance of this class so the 'current'
 * Matrix Client object is available easily.
 */
var MatrixClientPeg = function () {
    function MatrixClientPeg() {
        (0, _classCallCheck3.default)(this, MatrixClientPeg);

        this.matrixClient = null;
        this._justRegisteredUserId = null;

        // These are the default options used when when the
        // client is started in 'start'. These can be altered
        // at any time up to after the 'will_start_client'
        // event is finished processing.
        this.opts = {
            initialSyncLimit: 20
        };
        // the credentials used to init the current client object.
        // used if we tear it down & recreate it with a different store
        this._currentClientCreds = null;
    }

    /**
     * Sets the script href passed to the IndexedDB web worker
     * If set, a separate web worker will be started to run the IndexedDB
     * queries on.
     *
     * @param {string} script href to the script to be passed to the web worker
     */


    (0, _createClass3.default)(MatrixClientPeg, [{
        key: 'setIndexedDbWorkerScript',
        value: function setIndexedDbWorkerScript(script) {
            _createMatrixClient2.default.indexedDbWorkerScript = script;
        }
    }, {
        key: 'get',
        value: function get() {
            return this.matrixClient;
        }
    }, {
        key: 'unset',
        value: function unset() {
            this.matrixClient = null;

            _MatrixActionCreators2.default.stop();
        }

        /**
         * If we've registered a user ID we set this to the ID of the
         * user we've just registered. If they then go & log in, we
         * can send them to the welcome user (obviously this doesn't
         * guarentee they'll get a chat with the welcome user).
         *
         * @param {string} uid The user ID of the user we've just registered
         */

    }, {
        key: 'setJustRegisteredUserId',
        value: function setJustRegisteredUserId(uid) {
            this._justRegisteredUserId = uid;
        }

        /**
         * Returns true if the current user has just been registered by this
         * client as determined by setJustRegisteredUserId()
         *
         * @returns {bool} True if user has just been registered
         */

    }, {
        key: 'currentUserIsJustRegistered',
        value: function currentUserIsJustRegistered() {
            return this.matrixClient && this.matrixClient.credentials.userId === this._justRegisteredUserId;
        }

        /*
         * Replace this MatrixClientPeg's client with a client instance that has
         * homeserver / identity server URLs and active credentials
         */

    }, {
        key: 'replaceUsingCreds',
        value: function replaceUsingCreds(creds) {
            this._currentClientCreds = creds;
            this._createClient(creds);
        }
    }, {
        key: 'assign',
        value: async function assign() {
            var _arr = ['indexeddb', 'memory'];

            for (var _i = 0; _i < _arr.length; _i++) {
                var dbType = _arr[_i];
                try {
                    var promise = this.matrixClient.store.startup();
                    console.log("MatrixClientPeg: waiting for MatrixClient store to initialise");
                    await promise;
                    break;
                } catch (err) {
                    if (dbType === 'indexeddb') {
                        console.error('Error starting matrixclient store - falling back to memory store', err);
                        this.matrixClient.store = new _matrixJsSdk.MemoryStore({
                            localStorage: global.localStorage
                        });
                    } else {
                        console.error('Failed to start memory store!', err);
                        throw err;
                    }
                }
            }

            StorageManager.trackStores(this.matrixClient);

            // try to initialise e2e on the new client
            try {
                // check that we have a version of the js-sdk which includes initCrypto
                if (!_SettingsStore2.default.getValue("lowBandwidth") && this.matrixClient.initCrypto) {
                    await this.matrixClient.initCrypto();
                    StorageManager.setCryptoInitialised(true);
                }
            } catch (e) {
                if (e && e.name === 'InvalidCryptoStoreError') {
                    // The js-sdk found a crypto DB too new for it to use
                    var CryptoStoreTooNewDialog = _index2.default.getComponent("views.dialogs.CryptoStoreTooNewDialog");
                    _Modal2.default.createDialog(CryptoStoreTooNewDialog, {
                        host: window.location.host
                    });
                }
                // this can happen for a number of reasons, the most likely being
                // that the olm library was missing. It's not fatal.
                console.warn("Unable to initialise e2e", e);
            }

            var opts = _utils2.default.deepCopy(this.opts);
            // the react sdk doesn't work without this, so don't allow
            opts.pendingEventOrdering = "detached";
            opts.lazyLoadMembers = true;

            // Connect the matrix client to the dispatcher and setting handlers
            _MatrixActionCreators2.default.start(this.matrixClient);
            _MatrixClientBackedSettingsHandler2.default.matrixClient = this.matrixClient;

            return opts;
        }
    }, {
        key: 'start',
        value: async function start() {
            var opts = await this.assign();

            console.log('MatrixClientPeg: really starting MatrixClient');
            await this.get().startClient(opts);
            console.log('MatrixClientPeg: MatrixClient started');
        }
    }, {
        key: 'getCredentials',
        value: function getCredentials() {
            return {
                homeserverUrl: this.matrixClient.baseUrl,
                identityServerUrl: this.matrixClient.idBaseUrl,
                userId: this.matrixClient.credentials.userId,
                deviceId: this.matrixClient.getDeviceId(),
                accessToken: this.matrixClient.getAccessToken(),
                guest: this.matrixClient.isGuest()
            };
        }

        /*
         * Return the server name of the user's homeserver
         * Throws an error if unable to deduce the homeserver name
         * (eg. if the user is not logged in)
         */

    }, {
        key: 'getHomeserverName',
        value: function getHomeserverName() {
            var matches = /^@.+:(.+)$/.exec(this.matrixClient.credentials.userId);
            if (matches === null || matches.length < 1) {
                throw new Error("Failed to derive homeserver name from user ID!");
            }
            return matches[1];
        }
    }, {
        key: '_createClient',
        value: function _createClient(creds) {
            var opts = {
                baseUrl: creds.homeserverUrl,
                idBaseUrl: creds.identityServerUrl,
                accessToken: creds.accessToken,
                userId: creds.userId,
                deviceId: creds.deviceId,
                timelineSupport: true,
                forceTURN: !_SettingsStore2.default.getValue('webRtcAllowPeerToPeer', false),
                fallbackICEServerAllowed: !!_SettingsStore2.default.getValue('fallbackICEServerAllowed'),
                verificationMethods: [_crypto.verificationMethods.SAS],
                unstableClientRelationAggregation: true,
                identityServer: new _IdentityAuthClient2.default()
            };

            if (_SettingsStore2.default.isFeatureEnabled("feature_cross_signing")) {
                // TODO: Cross-signing keys are temporarily in memory only. A
                // separate task in the cross-signing project will build from here.
                var keys = [];
                opts.cryptoCallbacks = {
                    getCrossSigningKey: function getCrossSigningKey(k) {
                        return keys[k];
                    },
                    saveCrossSigningKeys: function saveCrossSigningKeys(newKeys) {
                        return (0, _assign2.default)(keys, newKeys);
                    }
                };
            }

            this.matrixClient = (0, _createMatrixClient2.default)(opts);

            // we're going to add eventlisteners for each matrix event tile, so the
            // potential number of event listeners is quite high.
            this.matrixClient.setMaxListeners(500);

            this.matrixClient.setGuest(Boolean(creds.guest));

            var notifTimelineSet = new _eventTimelineSet2.default(null, {
                timelineSupport: true
            });
            // XXX: what is our initial pagination token?! it somehow needs to be synchronised with /sync.
            notifTimelineSet.getLiveTimeline().setPaginationToken("", _eventTimeline2.default.BACKWARDS);
            this.matrixClient.setNotifTimelineSet(notifTimelineSet);
        }
    }]);
    return MatrixClientPeg;
}(); /*
     Copyright 2015, 2016 OpenMarket Ltd
     Copyright 2017 Vector Creations Ltd.
     Copyright 2017 New Vector Ltd
     
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
     
         http://www.apache.org/licenses/LICENSE-2.0
     
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
     */

if (!global.mxMatrixClientPeg) {
    global.mxMatrixClientPeg = new MatrixClientPeg();
}
exports.default = global.mxMatrixClientPeg;
module.exports = exports['default'];
//# sourceMappingURL=MatrixClientPeg.js.map